/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import context
 */
import { AppContext } from "context/appContext";
import { ContentContext } from "context/contentContext";

/**
 * import components
 */
import { Button__next } from "components/button/button";

/**
 * styled components
 */

const Container = styled.div`
  position: sticky;
  right: 0;
  bottom: 0;
  left: 0;
  ${t.mixins.flex()}
  min-height: 53px;
  font-family: ${t.font.primary};
  background-color: ${t.color.tertiary};
  color: ${t.color.white};
`;
const Content = styled.div`
  ${t.mixins.flex({ justify: "space-between" })}
  width: 100%;
  max-width: ${t.grid.width};

  ${t.mixins.sm(`
    ${t.mixins.flex()}
  `)}
`;
const Wrapper = styled.div`
  ${t.mixins.flex({ direction: "column", align: "flex-start" })}

  ${t.mixins.sm(`
    display: none;
  `)}
`;
const Title = styled.p`
  ${t.mixins.rem(18, 18)}
  padding-bottom: ${t.grid.space1};
`;
const Products = styled.div`
  ${t.mixins.flex({ justify: "flex-start" })}
`;
const Product = styled.div`
  ${t.mixins.flex()}
  padding-right: 36px;
`;
const ProductTitle = styled.div`
  padding-right: 10px;
`;
const Placeholder = styled.p`
  ${t.mixins.rem(16, 16)}
  font-family: ${t.font.primary};
  font-weight: ${t.font.light};
  font-style: italic;
`;

const Button = styled.button``;

/**
 * banner component is..
 */

const Content__banner = ({ style, products }) => {
  const { removeChoice } = useContext(AppContext);
  const { c } = useContext(ContentContext);
  const history = useHistory();
  const isEmpty = products.length === 0;
  const onSubmit = () => {
    if (!isEmpty) {
      history.push("/results");
    }
  };
  return (
    <Container style={style}>
      <Content>
        <Wrapper>
          <Title>{c("home.products.limit")}</Title>
          <Products>
            {isEmpty && <Placeholder>{c("home.products.empty")}</Placeholder>}
            {products.map(product => {
              const { skus, id } = product;
              return (
                <Product>
                  <ProductTitle>{skus}</ProductTitle>
                  <Button onClick={() => removeChoice(id)} size={11} color={t.color.white}>
                  </Button>
                </Product>
              );
            })}
          </Products>
        </Wrapper>
        <Button__next title={c('home.products.compare')} onClick={onSubmit} disabled={isEmpty} />
      </Content>
    </Container>
  );
};

export default Content__banner;

Content__banner.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Content__banner.defaultProps = {
  style: {},
};

/*
    import Content__banner from 'components/content/banner/content__banner'
    <Content__banner />
  */
